import { useAuthStore } from '@/stores/auth';

const DEFAULT_TZ = 'America/Sao_Paulo';

function isValidTz(tz: string): boolean {
  try {
    new Intl.DateTimeFormat('en-US', { timeZone: tz });
    return true;
  } catch {
    return false;
  }
}

/**
 * Mesma origem do server: o fuso da tela (`defaults.timezone`) vence o da criação
 * (`timezone`). Fonte: user.tenant.settings do /auth/me — não o DDD nem o relógio
 * do computador. Mudança em Config reflete no próximo /auth/me.
 */
// 44.1 (RC-010): fuso inválido cai no fallback EM SILÊNCIO era invisível em prod —
// warn identificável (1x por valor) para o fallback nunca mascarar config quebrada.
const warnedInvalidTz = new Set<string>();
function warnInvalidTz(tz: string) {
  if (warnedInvalidTz.has(tz)) return;
  warnedInvalidTz.add(tz);
  console.warn(`[RC-010] settings.timezone inválido ("${tz}") — usando fallback ${DEFAULT_TZ}`);
}

export function resolveTenantTimezone(settings: Record<string, unknown> | null | undefined): string {
  const nested = (settings?.defaults as Record<string, unknown> | undefined)?.timezone;
  if (typeof nested === 'string' && nested) {
    if (isValidTz(nested)) return nested;
    warnInvalidTz(nested);
  }
  const top = settings?.timezone;
  if (typeof top === 'string' && top) {
    if (isValidTz(top)) return top;
    warnInvalidTz(top);
  }
  return DEFAULT_TZ;
}

export function useTenantTimezone(): string {
  const settings = useAuthStore(
    (s) => (s.user as { tenant?: { settings?: Record<string, unknown> | null } } | null)?.tenant?.settings ?? null,
  );
  return resolveTenantTimezone(settings);
}
